import { TRACK_RECORD } from '../../../core/constants/landing';
import { BRAND } from '../../../core/constants/site';
import { IconStar } from '../../../common/icons';
import Reveal from '../../../common/components/Reveal/Reveal';

import '../styles/track-record.css';

export default function TrackRecord() {
    const currentYear = new Date().getFullYear();

    return (
        <section id="trayectoria" className="track-record section" aria-labelledby="track-record-title">
            <div className="container">
                <div className="track-record__intro">
                    <Reveal>
                        <p className="eyebrow">Trayectoria</p>
                        <h2 id="track-record-title" className="section__title">{TRACK_RECORD.title}</h2>
                    </Reveal>
                    <Reveal as="p" className="track-record__text">{TRACK_RECORD.text}</Reveal>
                </div>

                <Reveal className="track-record__timeline" aria-hidden="true">
                    <span className="track-record__year">{BRAND.foundingYear}</span>
                    <span className="track-record__ruler" />
                    <span className="track-record__year">{currentYear}</span>
                </Reveal>

                <dl className="track-record__stats">
                    {TRACK_RECORD.stats.map(stat => (
                        <Reveal className="track-record__stat" key={stat.id}>
                            <dt className="track-record__label">{stat.label}</dt>
                            <dd className="track-record__value">
                                {stat.value}
                                {stat.hasStar && (
                                    <span className="track-record__star"><IconStar size={28} /></span>
                                )}
                            </dd>
                        </Reveal>
                    ))}
                </dl>
            </div>
        </section>
    );
}
